export default __webpack_public_path__ + "static/media/exclamation.5029044f.png";